import React, { useState } from 'react';
import TabBar from './TabBar';
import PagesTab from './PagesTab';
import LayersTab from './LayersTab';
import SettingsTab from './SettingsTab';
import { usePageBuilder } from '../context/PageBuilderContext';

/**
 * LeftPanel - Main container for the page builder left sidebar
 *
 * Consumes builder state via PageBuilderContext instead of prop drilling.
 * Features a tabbed interface with:
 * - Pages: Placeholder for future multi-page support
 * - Layers: Tree view of all sections and components
 * - Settings: Page-level configuration
 */
export default function LeftPanel() {
  const { doc, selection, chrome, page, onRefreshPage, sensors, handlers } = usePageBuilder();
  const [activeTab, setActiveTab] = useState('pages');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'pages':
        return <PagesTab page={page} onRefreshPage={onRefreshPage} />;
      case 'layers':
        return (
          <LayersTab
            sections={doc.sections}
            selectedSection={selection.selectedSection}
            setSelectedSection={selection.setSelectedSection}
            allSectionTypes={doc.allSectionTypes}
            addSectionDirectly={handlers.addSectionDirectly}
            handleDeleteSection={handlers.handleDeleteSection}
            handleQuickUpdate={handlers.handleQuickUpdate}
            handleDragEnd={handlers.handleDragEnd}
            sensors={sensors}
            onShowComponentPalette={handlers.handleLayersShowComponentPalette}
            onMoveComponent={handlers.handleMoveComponent}
            onOpenTemplateLibrary={() => chrome.modals.templateLibrary.open()}
            onExportSection={(section) => chrome.modals.exportSection.open(section)}
            onImportSection={() => chrome.modals.importModal.open()}
            onReorderSections={handlers.handleReorderSections}
            page={page}
            onUpdateSection={handlers.handleUpdateSection}
            siteSections={doc.siteSections}
            onCreateSiteSection={doc.createSiteSection}
            onUpdateSiteSection={doc.updateSiteSection}
            onRefreshSiteSections={() => page?.site_id && doc.fetchSiteSections(page.site_id)}
            onAddSiteSection={handlers.addSiteSection}
          />
        );
      case 'settings':
        return (
          <SettingsTab
            pageConfig={doc.pageConfig}
            updatePageConfig={doc.updatePageConfig}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div
      className="flex flex-col h-full bg-white border-r border-gray-200"
      style={{ width: `${chrome.panelWidths.left}%` }}
    >
      <TabBar activeTab={activeTab} onTabChange={setActiveTab} />
      <div className="flex-1 overflow-y-auto">
        {renderTabContent()}
      </div>
    </div>
  );
}
